import { useFormat } from '@ideavivat/vivat-2';

const toDecimalFormat = (string: string) => useFormat.number(string).currency();
// parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const shortWidth = '6rem';
const longWidth = '10rem';
const textClass = 'text-right';

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    uniqueId: {
      name: 'เลขใบจัดรถ',
      width: '1fr',
    },
    driverFee: {
      name: 'ค่าเที่ยว',
      width: shortWidth,
      class: textClass,
      filter: (val: string, row: any) => toDecimalFormat(row.item.deliveryCashFlow.driverFee || 0),
    },
    driverAllowance: {
      name: 'เบี้ยเลี้ยง',
      width: shortWidth,
      class: textClass,
      filter: (val: string, row: any) => toDecimalFormat(row.item.deliveryCashFlow.driverAllowance || 0),
    },
    driverPenalty: {
      name: 'ค่าปรับ',
      width: shortWidth,
      class: textClass,
      filter: (val: string, row: any) => toDecimalFormat(row.item.deliveryCashFlow.driverPenalty || 0),
    },
    staffFee: {
      name: 'ค่าเที่ยว พนง. ยกของ',
      width: longWidth,
      class: textClass,
      filter: (val: string, row: any) => toDecimalFormat(row.item.deliveryCashFlow.staffFee || 0),
    },
    staffAllowance: {
      name: 'เบี้ยเลี้ยง พนง. ยกของ',
      width: longWidth,
      class: textClass,
      filter: (val: string, row: any) => toDecimalFormat(row.item.deliveryCashFlow.staffAllowance || 0),
    },
    staffPenalty: {
      name: 'ค่าปรับ พนง. ยกของ',
      width: longWidth,
      class: textClass,
      filter: (val: string, row: any) => toDecimalFormat(row.item.deliveryCashFlow.staffPenalty || 0),
    },
    expressWay: {
      name: 'ค่าทางด่วน',
      width: shortWidth,
      class: textClass,
      filter: (val: string, row: any) => toDecimalFormat(row.item.deliveryCashFlow.expressWay || 0),
    },
    fuel: {
      name: 'ค่าน้ำมัน',
      width: shortWidth,
      class: textClass,
      filter: (val: string, row: any) => toDecimalFormat(row.item.deliveryCashFlow.fuel || 0),
    },
    deliveryCashFlow: {
      name: 'รวม',
      width: shortWidth,
      class: textClass,
      filter: (val: any) => {
        const {
          driverFee,
          driverAllowance,
          driverPenalty,
          staffFee,
          staffAllowance,
          staffPenalty,
          expressWay,
          fuel,
        } = val;
        return toDecimalFormat(driverFee + driverAllowance + driverPenalty + staffFee + staffAllowance + staffPenalty + expressWay + fuel);
      },
    },
    deliveryDate: {
      name: 'วันที่',
      width: '6rem',
      class: 'text-right',
      filter: (val: string) => useFormat.date(val).displayShortThaiDate(),
    },
  },
  sortable: [
    'uniqueId',
  ],
};
